// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-create-application-notes) {
  height: 100%;
  width: 98%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.note-text {
  resize: none;
  border: none Transparent;
  outline: none;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  margin-left: 5px;
  margin-right: 5px;
  width: 100%;
}

.margin-bottom {
  margin-bottom: 15px;
}

.noteLabel {
  width: 90px;
}

.add-note-row {
  margin-bottom: 15px;
}

.note-form {
  height: 100%;
}

.note-row {
  margin-bottom: 5px;
  border-bottom: 1px solid lightgray;
  padding-bottom: 5px;
}

.remove-button {
  margin-left: 10px;
}

.note {
  margin-bottom: 0px;
  color: black;
  display: flex;
  align-items: center;
}

textarea:disabled {
  background-color: lightgrey !important;
}

.form-control:disabled {
  background-color: lightgrey !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
